import { useState, useEffect } from "react";
import {
    StyleSheet, View, Text
} from "react-native";

import { FONT } from "../../../value/staticValues";
import { PLATFORM_URL } from "../../../value/Url";
import { requests } from "../../../common/RestAPI";

import { CustomTextInput, TextArea } from "../../base/CustomInputText";
import { CustomDropDown, DropdownType } from "../../base/CustomDropdown";
import CustomRadioBtn from "../../base/CustomRadioBtn";

import { ReactComponent as MsgInfoImg } from '../../../img/ico-msg-info-2.svg';
import { ReactComponent as AddFileImg } from '../../../img/ico-prefix-add-file.svg';
import { ReactComponent as AddFileWhiteImg } from '../../../img/ico-prefix-add-file-white.svg';

import { guestOsDropdownItem, imageFormatDropdownItem } from "./VmImageData";
import { useTranslation } from "react-i18next";
import { CustomInputFileBtn } from "../../base/CustomInputFileBtn";
import { CustomSquareCheckBox } from "components/base/CustomCheckBox";
import CustomText from "components/base/CustomText";



interface VmImageAddProps {
    showMessageCb?: Function,
    showLoadingCb?: Function,
    showSlideModalCb?: Function,
    stepIndex: number,
    clickedConfirmYn: boolean,
    resultCb?: Function,
    stepCount: number,
};


export default function VmImageAdd(props:VmImageAddProps) {
    const { t } = useTranslation();

    const [stepIndex, setStepIndex] = useState(0);
    const [executeAddYn, setExecuteAddYn] = useState(false);

    const [vmImageName, setVmImageName] = useState("");
    const [vmImageDesc, setVmImageDesc] = useState("");
    const [vmImageFormat, setVmImageFormat] = useState(imageFormatDropdownItem[2].value);
    const [vmImageFormatLabel, setVmImageFormatLabel] = useState(imageFormatDropdownItem[2].label);
    const [guestOs, setGuestOs] = useState(guestOsDropdownItem[0].value);
    const [useClusterYn, setUseClusterYn] = useState(false)
    const [targetId, setTargetId] = useState("");
    const [vmImagePubType, setVmImagePubType] = useState("PUB");
    const [diskFile, setDiskFile] = useState<FileList|null>(null);

    const [projectList, setProjectList] = useState<DropdownType[]>([ { value: "", label: t("EMPTY_TEXT")} ]);

    const [vmImageNameWarnYn, setVmImageNameWarnYn] = useState(false);

    useEffect(() => {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }
        setStepIndex(props.stepIndex);
    }, [props.stepIndex]);


    useEffect(() => {
        if(props.clickedConfirmYn === true) {
            if(stepIndex < props.stepCount - 1) {
                if(stepIndex === 0) {

                }
            } else {
                const successYn = checkVmImageData();
                if(successYn) {
                    setExecuteAddYn(true);
                } else {
                    executeResult({successYn: false}, false, '');;
                }
            }

        }
    }, [props.clickedConfirmYn]);


    useEffect(() => {
        loadProjectList()
    }, [])


    useEffect(() => {
        if(executeAddYn) {
            executeAddVmImage();
        }
    }, [executeAddYn]);


    useEffect(() => {
        if(diskFile && diskFile.length > 0) {
            const reader = new FileReader();
            reader.onload = function(e) {
                if(e.target && e.target.result) {
                    if(e.target.result.toString().indexOf("QFI") > -1) {
                        setVmImageFormat('QCOW');
                        setVmImageFormatLabel('QCOW2');
                    } else if(e.target.result.toString().indexOf("CD001") > -1) {
                        setVmImageFormat('ISO');
                        setVmImageFormatLabel('ISO');
                    } else {
                        setVmImageFormat('RAW');
                        setVmImageFormatLabel('RAW');
                    }
                }
            }
            reader.readAsText((diskFile[0].slice(0, 32777)));
        }
    }, [diskFile]);



    function loadProjectList() {
        requests.get(PLATFORM_URL.PROJECT, {size: 9999})
        .then((response) => {
            if (response.status === 200 && response.data?.items) {
                setProjectList(response.data.items.map((v) => {
                    return {
                        value: v.project_id,
                        label: v.project_name
                    }
                }))
            }
        })
    }


    function checkVmImageData() {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }
        setVmImageNameWarnYn(false);


        let message = "";
        let error = false;
        if(!vmImageName) {
            message = t("MESSAGE_VM_IMAGE_INFO_ENTER_ERROR_MESSAGE")
            setVmImageNameWarnYn(true);
            error = true;
        }
        if(!diskFile) {
            message = t("MESSAGE_VM_IMAGE_FILE_ENTER_ERROR_MESSAGE")
            error = true;
        }
        if(error === true) {
            executeResult({}, false, message);
        }
        return !error;
    }

    function executeResult(result, closeYn, infoMessage) {
        setExecuteAddYn(false);
        if(props.showMessageCb && infoMessage) {
            props.showMessageCb(infoMessage);
        }
        if(props.resultCb) {
            props.resultCb(result, closeYn);
        }
    }


    function executeAddVmImage() {

        const addVmImageData = {
            vm_image : {
                vm_image_name: vmImageName,
                vm_image_description: vmImageDesc,
                vm_image_format_type_code: vmImageFormat,
                share_type_code: vmImagePubType,
                os_type_code: guestOs,
                container_vm_image_yn: useClusterYn
            }
        };
        if(vmImagePubType !== "PUB") {
            addVmImageData["project"] = {project_id: targetId}
        }

        const addFormPackage = new FormData();
        addFormPackage.append("data", JSON.stringify(addVmImageData))

        if (diskFile && diskFile.length > 0) {
            addFormPackage.append("vm_image_file", diskFile[0]);
        }

        requests.post(PLATFORM_URL.VM_IMAGE, addFormPackage)
        .then((response) => {
            if(response.status === 200) {
                executeResult({successYn: true }, true, "");
            } else if(response.status === 409) {
                executeResult({successYn: false}, false, t("MESSAGE_VM_IMAGE_ADD_DUPLICATED_ERROR_MESSAGE"));
            } else {
                executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
            }
        })
        .catch((error) => {
            if(error.status === 409) {
                executeResult({successYn: false}, false, t("MESSAGE_VM_IMAGE_ADD_DUPLICATED_ERROR_MESSAGE"));
            } else {
                executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
            }
        });
    }

    function selectButton(id, type){
        setVmImagePubType(type);
    }



    return (
        <View>
            {
                stepIndex === 0 ?
                // 이름, 설명, 사용 유형, 사용 대상
                <View>
                    <View style={style.infoBoxContainer}>
                        <MsgInfoImg/>
                        <Text style={style.infoBoxContainerText}>
                            {t("VM_IMAGE_ADD_INFO_MESSAGE")}
                        </Text>
                    </View>
                    <Text style={style.titleText}>{
                        t("BASE_INFO_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        <View style={style.rowContainer}>
                            <CustomText text={t("VN_IMAGE_NAME_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomTextInput
                                key={2}
                                width={570} height={36}
                                value={vmImageName}
                                type={"text"}
                                activeYn={true}
                                inputCb={setVmImageName}
                                warnYn={vmImageNameWarnYn}
                                placeHolderText={t("NAME_ENTER_MESSAGE")}
                            />
                        </View>
                        <View style={style.rowTopAlignContainer}>
                            <Text style={style.columnText}>
                                {t("DESCRIPTION_TEXT")}
                            </Text>
                            <TextArea
                                key={3}
                                width={570}
                                height={100}
                                value={vmImageDesc}
                                type={"text"}
                                activeYn={true}
                                inputCb={setVmImageDesc}
                                warnYn={false}
                                placeHolderText={t("DESCRIPTION_ENTER_MESSAGE")}
                            />
                        </View>
                        <View style={style.rowDivContainer}/>
                    </View>
                    <Text style={style.titleText}>{
                        t("IMAGE_FILE_INFO_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        <View style={style.rowContainer}>
                            <CustomText text={t("FILE_IMPORT_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomInputFileBtn
                                size={{width: 116, height: 36}}
                                text={t("FILE_SELECT_TEXT")}
                                img={{
                                    active: <AddFileWhiteImg/>,
                                    inactive: <AddFileImg/>
                                }}
                                value={diskFile}
                                inputCb={setDiskFile}
                            />
                        </View>
                        <View style={style.rowContainer}>
                            <CustomText text={t("FORMAT_TYPE_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            {
                                diskFile
                                ?
                                <CustomDropDown
                                    key={5}
                                    width={300} height={36}
                                    items={imageFormatDropdownItem}
                                    setValue={setVmImageFormat}
                                    disable={false}
                                    value={vmImageFormat}
                                    defaultvalue={{value: vmImageFormat, label: vmImageFormatLabel}}
                                />
                                :
                                <CustomDropDown
                                    key={5}
                                    width={300} height={36}
                                    items={imageFormatDropdownItem}
                                    setValue={setVmImageFormat}
                                    disable={true}
                                    value={vmImageFormat}
                                    defaultvalue={{value: vmImageFormat, label: vmImageFormatLabel}}
                                />
                            }
                        </View>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("GUEST_OS_TEXT")}
                            </Text>
                            <CustomDropDown
                                key={5}
                                width={300} height={36}
                                items={guestOsDropdownItem}
                                setValue={setGuestOs}
                                disable={false}
                                defaultvalue={{value: "NONE", label: t("EMPTY_TEXT")}}
                            />
                        </View>
                        <View style={{flexDirection: "row", alignItems: "center"}}>
                            <View style={{flexDirection: "row", alignItems: "center", marginBottom: 16}}>
                            <Text style={style.columnText}>
                                    {t("VM_IMAGE_ADD_USE_CLUSTER_TYPE_TEXT")}
                                </Text>
                                <CustomSquareCheckBox
                                    size={107}
                                    label={t("VM_IMAGE_ADD_USE_CLUSTER_TYPE_TEXT")}
                                    id={"ResourceCheckbox"}
                                    checked={useClusterYn}
                                    disabled={false}
                                    textStyle={{
                                        fontFamily: FONT.REGULAR,
                                        fontSize: "12px",
                                        color: "#333"
                                    }}
                                    setCheckBoxStatus={()=>{setUseClusterYn(!useClusterYn)}}
                                />
                            </View>
                        </View>
                        <View style={style.rowDivContainer}/>
                    </View>
                    <Text style={style.titleText}>{
                        t("SHARE_INFO_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        <View style={style.rowContainer}>
                            <CustomText text={t("SHARE_CATEGORY_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomRadioBtn
                                id={"VmImageShareType"}
                                type={"PUB"}
                                size={18}
                                checked={vmImagePubType === "PUB" ? true: false}
                                selectCb={selectButton}
                                label={"공용(Pubilc)"}
                                labelStyle={labelStyle}
                            />
                            <View style={{width: 44}}/>
                            <CustomRadioBtn
                                id={"VmImageShareType"}
                                type={"PRJ"}
                                size={18}
                                checked={vmImagePubType === "PRJ" ? true: false}
                                selectCb={selectButton}
                                label={"개인(프로젝트)"}
                                labelStyle={labelStyle}
                            />
                        </View>
                        {
                            vmImagePubType !== "PUB" ?
                            <View style={style.rowContainer}>
                                <CustomText text={t("PROJECT_INFO_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                                <CustomDropDown
                                    key={10}
                                    width={300} height={36}
                                    items={projectList}
                                    setValue={setTargetId}
                                    disable={false}
                                    defaultvalue={{label: projectList[0]?.label, value: projectList[0]?.value}}
                                />
                            </View>
                            : null
                        }
                    </View>
                </View>
                : null
            }
        </View>
    );
}


const style = StyleSheet.create({
    titleText: {
        marginTop: 40,
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        fontWeight: "500",
        color: "#0853fb",

    },
    mainContainer: {
        marginTop: 38
    },
    rowContainer: {
        height: 36,
        flexDirection: "row",
        marginBottom: 30,
        alignItems: "center"
    },
    rowTopAlignContainer: {
        minHeight: 36,
        flexDirection: "row",
        marginBottom: 30,
    },
    rowDivContainer: {
        borderStyle: "solid",
        borderBottomWidth: 1,
        borderBottomColor: "#eee",
        marginBottom: 30,
    },
    rowDescribeContainer: {
        marginLeft: 150, marginTop: -10, marginBottom: 40,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 12,
        color: "#8c8c8c"
    },
    columnText: {
        width: 150,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        color: "#333",
    },
    infoBoxContainer: {
        flexDirection: "row", alignItems: "center",
        width: 700, height: 40,
        paddingLeft: 10, paddingRight: 10,
        marginBottom: 15,
        borderRadius: 2,
        backgroundColor: "#fafafa"
    },
    infoBoxContainerText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 18,
        color: "#9ea0a5"
    },
});


const labelStyle = {
    fontFamily: FONT.REGULAR,
    fontSize: 12,
    color: "#333"
}


VmImageAdd.defaultProps = {
    stepIndex: 0,
    clickedConfirmYn: false,
    stepCount: 1,
}